import styled from 'styled-components';
import colors from '../../../helpers/colors';
import spacing from '../../../helpers/spacing';
import { Grid, GridItem } from '../../Grid';
import RichText from '../../RichText';

export const MobileGrid = styled(Grid)`
  display: flex;
`;

export const MobilePanelSectionContainer = styled(GridItem)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  background: ${colors.neutral08};
`;

export const MobileGridItem = styled(GridItem)<{ isSelected: boolean }>`
  display: ${({ isSelected }) => (isSelected ? 'flex' : 'none')};
  padding: ${spacing(3)} 0;
  margin: 0;
  width: 100%;
  border-bottom: solid 1px ${colors.neutral04};
`;

export const PanelRichText = styled(RichText)``;
